import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'logo',
        title: i18n.t('label.logo'),
        template: (row) => '<img src="'+row.logo+'" width="60" />',
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'fa_name',
        title: i18n.t('label.fa_name'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'en_name',
        title: i18n.t('label.en_name'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'gateway',
        title: i18n.t('label.gateway_connection'),
        sortable: false,
        textAlign: 'center',
        template: (row) => row.gateway 
            ? '<span dir="ltr">'+row.gateway+'</span>' 
            : '<span>'+i18n.t('label.default_gateway')+'</span>',
        width: 140
    },
]